import "../assets/css/menus.css";
import { useState, useEffect } from "react";
import { Loading } from "../components/loading";
import { MediaSlider } from "../components/mediaSlider";

export const Menus = ({ menus, isShowSectionTitle = true }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (menus && menus.length > 0) {
      setLoading(false);
    }
  }, [menus, isShowSectionTitle]);

  return (
    <section id="menus">
      {loading ? (
        <Loading />
      ) : (
        <div className="menus-container">
          {isShowSectionTitle && (
            <div>
              <h3>MENUS</h3>
              <hr />
            </div>
          )}
          <MediaSlider mediaList={menus} />
        </div>
      )}
    </section>
  );
};
